module.exports = __webpack_public_path__ + "media/images/athletes/1674-6db7afa88ad910464338a6a11a801e71.png";